export default __webpack_public_path__ + "static/prebid-partner-c40da82a760af3ff4cbb02fb559cedf5.svg";